import { render, staticRenderFns } from "./NoChat.vue?vue&type=template&id=6b53d5b7&scoped=true&"
import script from "./NoChat.vue?vue&type=script&lang=js&"
export * from "./NoChat.vue?vue&type=script&lang=js&"
import style0 from "./NoChat.vue?vue&type=style&index=0&id=6b53d5b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b53d5b7",
  null
  
)

export default component.exports